import { apiRequest } from "@services/apiClient";
import beforeYouGoEndpoints from "@services/beforeYouGo/beforeYouGoEndpoints";

function readLocalizedValue(entry) {
  if (typeof entry === "string") return entry;
  if (entry && typeof entry === "object") return entry.value || "";
  return "";
}

function normalizeLocalizedMap(map = {}) {
  return Object.entries(map || {}).reduce((acc, [iso, value]) => {
    acc[iso] = readLocalizedValue(value);
    return acc;
  }, {});
}

function normalizeLocalizedIdsMap(map = {}) {
  return Object.entries(map || {}).reduce((acc, [iso, value]) => {
    acc[iso] =
      value && typeof value === "object" ? String(value.id || "") : "";
    return acc;
  }, {});
}

function normalizeBeforeYouGoItemFromApi(item = {}) {
  return {
    id: String(item?.id || ""),
    itemType: String(item?.itemType || "hotel"),
    order: Number(item?.order || 0) || 0,
    displayOrder: Number(item?.displayOrder || 0) || 0,
    title: normalizeLocalizedMap(item?.title || {}),
    titleTranslationIds: normalizeLocalizedIdsMap(item?.title || {}),
    location: String(item?.location || ""),
    description: normalizeLocalizedMap(item?.description || {}),
    descriptionTranslationIds: normalizeLocalizedIdsMap(
      item?.description || {},
    ),
    rating:
      item?.rating === null || typeof item?.rating === "undefined"
        ? ""
        : String(item.rating),
    websiteUrl: String(item?.websiteUrl || ""),
    imageUrl: String(item?.imageUrl || ""),
    image: item?.image
      ? {
          id: item?.image?.id || "",
          url: item?.image?.url || "",
          mediaType: item?.image?.mediaType || "image",
          mimeType: item?.image?.mimeType || "image/*",
        }
      : null,
  };
}

export function normalizeBeforeYouGoSectionFromApi(section = {}) {
  return {
    id: String(section?.id || ""),
    itemType: String(section?.itemType || "category"),
    order: Number(section?.order || 0) || 0,
    title: normalizeLocalizedMap(section?.title || {}),
    titleTranslationIds: normalizeLocalizedIdsMap(section?.title || {}),
    iconName: String(section?.iconName || "star"),
    imageUrl: String(section?.imageUrl || ""),
    image: section?.image
      ? {
          id: section?.image?.id || "",
          url: section?.image?.url || "",
          mediaType: section?.image?.mediaType || "image",
          mimeType: section?.image?.mimeType || "image/*",
        }
      : null,
    descriptions: normalizeLocalizedMap(section?.descriptions || {}),
    descriptionTranslationIds: normalizeLocalizedIdsMap(
      section?.descriptions || {},
    ),
    items: (Array.isArray(section?.items) ? section.items : []).map(
      normalizeBeforeYouGoItemFromApi,
    ),
  };
}

export function listBeforeYouGoByTourRequest(tourId) {
  return apiRequest(beforeYouGoEndpoints.byTour(tourId));
}

export function createBeforeYouGoRequest(payload) {
  return apiRequest(beforeYouGoEndpoints.base, {
    method: "POST",
    body: payload,
  });
}
